import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class OnlyAdminEmpresaGuard {
  constructor(private readonly sessionService: SessionService, private readonly router: Router) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const role = this.sessionService.getSession().role;

    switch (role) {
      case 'Admin':
        return true;
      case 'Master':
        return true;
      case 'Doctor':
        return true;
      default:
        return this.router.navigateByUrl('/dash/filiais');
    }
  }
}
